import React from "react";
import Login from "./Auth/Login/Login";
import Signup from "./Auth/Signup/Signup";
import Redem from "./Redemscreen/Redemscreen";
import Profile from "./Profile/Profile";
import Home from "./HomePage/Home";
// import Header from './Common/Header/Header';
import QrContainer from "./QrReader/QrReader";
// import ScanQrCode from './ScanQrCode';
import Rewards from "./Rewards";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Gifts from "./Gifts/Gifts";
import transitions from "@material-ui/core/styles/transitions";
import Transaction from "./Transactions/Transaction";
import Company from "./Company/Company";
import Video from "./Video";
import Barcode from "./Barcode";
const App = () => {
  return (
    <>
      <Router>
        <Switch>
          <Route component={Login} path="/" exact />
          <Route restricted={false} component={Signup} path="/signup" exact />
          <Route component={Home} path="/home" exact></Route>
          <Route component={Company} path="/company" exact />
          <Route component={Gifts} path="/gifts" exact />
          <Route component={Transaction} path="/transactions" exact />
          <Route component={Profile} path="/profile" exact />
          <Route component={QrContainer} path="/qrcode" exact />
          {/* <Route component={ScanQrCode} path="/qr" exact /> */}
          <Route component={Rewards} path="/rewards" exact />
          <Route component={Video} path="/playvideo" exact />
          <Route component={Barcode} path="/showBarcode" exact />
        </Switch>
      </Router>
    </>
  );
};
export default App;
